var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryCreative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-704.000000, -810.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.000000, 127.000000)",
    id: "gift-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8717949,0 C9.31635897,0 8.43471795,1.19833333 8,2.06 C7.56528205,1.19833333 6.68364103,0 5.12820513,0 C4.13851282,0 3.33333333,0.747666667 3.33333333,1.66666667 C3.33333333,2.58566667 4.13851282,3.33333333 5.12820513,3.33333333 L8,3.33333333 L10.8717949,3.33333333 C11.8614872,3.33333333 12.6666667,2.58566667 12.6666667,1.66666667 C12.6666667,0.747666667 11.8614872,0 10.8717949,0 Z M5.12820513,2.66666667 C4.53446154,2.66666667 4.05128205,2.218 4.05128205,1.66666667 C4.05128205,1.11533333 4.53446154,0.666666667 5.12820513,0.666666667 C6.4725641,0.666666667 7.20523077,1.97466667 7.49851282,2.66666667 L5.12820513,2.66666667 Z M10.8717949,2.66666667 L8.50041026,2.66666667 C8.79189744,1.975 9.52205128,0.666666667 10.8717949,0.666666667 C11.4655385,0.666666667 11.9487179,1.11533333 11.9487179,1.66666667 C11.9487179,2.218 11.4655385,2.66666667 10.8717949,2.66666667 Z",
    id: "Shape",
    fill: "#D1B43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,4.66666667 L1.33333333,4.66666667 L1.33333333,15.2916667 C1.33333333,15.6830208 1.64736842,16 2.03508772,16 L13.9649123,16 C14.3526316,16 14.6666667,15.6830208 14.6666667,15.2916667 L14.6666667,4.66666667 Z",
    id: "Path",
    fill: "#C94F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3043478,2.66666667 L0.695652174,2.66666667 C0.311304348,2.66666667 0,2.965 0,3.33333333 L0,5.33333333 C0,5.70166667 0.311304348,6 0.695652174,6 L15.3043478,6 C15.6886957,6 16,5.70166667 16,5.33333333 L16,3.33333333 C16,2.965 15.6886957,2.66666667 15.3043478,2.66666667 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EFD358",
    x: 6.66666667,
    y: 2.66666667,
    width: 3.33333333,
    height: 3.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D1B43D",
    x: 6.66666667,
    y: 6,
    width: 3.33333333,
    height: 10
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryCreative);
export default __webpack_public_path__ + "static/media/category_creative.ecf096959e64a6e18300ccf85d439a86.svg";
export { ForwardRef as ReactComponent };